import { z } from "zod";

export const addUiUmSchema = z.object({
    idUUID: z.string().nullable().optional(),
    idCaseID: z.string().nullable().optional(),
    claimNumber: z.string().nullable(),
    idCompanyID: z.string().nullable(),
    idAdjuster: z.string().optional().default(""),
    idRoleID: z.string().nullable().optional(),

    namePrefix: z.string().nullable().optional(),
    nameFirst: z.string().optional().nullable().default(""),
    nameI: z.string().nullable().optional(),
    nameLast: z.string().optional().nullable().default(""),
    nameSuffix: z.string().nullable().optional(),
    nameAKA: z.string().nullable().optional(),

    address: z.string().nullable().optional(),
    address2: z.string().nullable().optional(),
    city: z.string().nullable().optional(),
    state: z.string().nullable().optional(),
    zip: z.string().nullable().optional(),

    phoneNumber: z.string().nullable().optional(),
    phoneExtension: z.string().nullable().optional(),
    faxNumber: z.string().nullable().optional(),
    email: z.string().nullable().optional(),

    policyPersonCoverageMM: z.string().nullable().optional(),
    policyVehiculeCoverageMM: z.string().nullable().optional(),
    policyInsuredName: z.string().min(1, "Insured name is required"),
    policyDriverName: z.string().nullable().optional(),
    formLimits: z.string().nullable().optional(),
    coverageType: z.string().nullable().optional(),
    medpay: z.string().nullable().optional(),
});
